import { model as lolCompetitiveMatchesModel } from "@/game-lol/models/lol-competitive-matches.mjs";
import { model as lolMatchListModel } from "@/game-lol/models/lol-match-list.mjs";
import { model as lolMatchRankStatsModel } from "@/game-lol/models/lol-match-rank-stats.mjs";
import { model as lolPlayerBasicChampionStatsModel } from "@/game-lol/models/lol-player-champion-basic-stats.mjs";
import { model as lolPlayerChampionSeasonModel } from "@/game-lol/models/lol-player-champion-season-stats.mjs";
import { model as lolPlayerChampionStatsModel } from "@/game-lol/models/lol-player-champion-stats.mjs";
import { model as lolPlayerStylesModel } from "@/game-lol/models/lol-player-styles.mjs";
import { model as lolSummonerModel } from "@/game-lol/models/lol-summoner.mjs";
import { model as lolSummonerWithoutRanksModel } from "@/game-lol/models/lol-summoner-wo-ranks.mjs";
import gql from "@/util/graphql-query.mjs";

export const LeagueProfile = gql`
query LeagueProfile(
  $summoner_name: String
  $summoner_id: String
  $account_id: String
  $region: Region!
  $puuid: String
  $gameName: String
  $tagLine: String
) {
  leagueProfile(
    summoner_name: $summoner_name
    summoner_id: $summoner_id
    account_id: $account_id
    region: $region
    puuid: $puuid
    gameName: $gameName
    tagLine: $tagLine
  ) {
    ranks(first: 30) { ${lolSummonerModel.ranks} }
    ${lolSummonerWithoutRanksModel}
  }
}`;

export const LeagueMatchlist = gql`
  query LeagueMatchlist($region: Region!, $puuid: ID!) {
    matchlist(region: $region, puuid: $puuid) { ${lolMatchListModel} }
  }
`;

export const rankStatsQuery = gql`
  query DivisionStats($queue: Queue!, $role: Role, $championId: Int) {
    divisionStats(queue: $queue, role: $role, championId: $championId) { ${lolMatchRankStatsModel} }
  }
`;

export const fetchUserChampions = gql`
  query PlayerChampionStats(
    $leagueProfileId: ID!
    $region: Region!
    $queue: Queue!
    $championId: Int
    $role: Role
  ) {
    playerChampionsStats(
      leagueProfileId: $leagueProfileId
      region: $region
      queue: $queue
      championId: $championId
      role: $role
    ) { ${lolPlayerChampionStatsModel} }
  }
`;

export const fetchUserChampionsSeason = gql`
  query PlayerChampionSeasonStats(
    $leagueProfileId: ID!
    $region: Region!
    $queue: Queue!
    $season: Int!
  ) {
    playerChampionsSeasonStats(
      leagueProfileId: $leagueProfileId
      region: $region
      queue: $queue
      season: $season
    ) { ${lolPlayerChampionSeasonModel} }
  }
`;

export const fetchUserBasicChampions = gql`
  query PlayerChampionStats(
    $leagueProfileId: ID!
    $region: Region!
    $queue: Queue!
    $championId: Int
    $role: Role
  ) {
    playerChampionsStats(
      leagueProfileId: $leagueProfileId
      region: $region
      queue: $queue
      championId: $championId
      role: $role
    ) { ${lolPlayerBasicChampionStatsModel} }
  }
`;

export const LeagueMatch = gql`
  query LeagueMatch($region: Region!, $matchId: ID!) {
    match(region: $region, matchId: $matchId)
  }
`;

export const CompetitiveMatches = gql`
  query CompetitiveHistory($championId: Int!, $role: Role, $first: Int, $tournamentTypes: [String]) {
    probuildsCompetitiveMatches(championId: $championId, role: $role, first: $first, tournamentTypes: $tournamentTypes) { ${lolCompetitiveMatchesModel} }
  }`;

export const LeagueTimeline = gql`
  query LeagueTimeline($region: Region!, $matchId: ID!) {
    timeline(region: $region, matchId: $matchId)
  }
`;

export const playstyles = gql`
  query playstyles($region: Region!, $leagueProfileId: ID!, $queue: Queue) {
    playstyles(region: $region, leagueProfileId: $leagueProfileId, queue: $queue) { ${lolPlayerStylesModel} }
  }
`;

export const updateSummonerLpStats = gql`
  mutation UpdateSummonerLpStats(
    $region: Region!
    $leagueProfileId: ID!
    $queue: Queue!
    $role: Role!
    $championId: Int!
    $lp: Int!
    $gameId: String!
    $deltaLp: Int!
    $division: Division!
    $tier: Tier!
  ) {
    savePlayerMatchStatsFromClient(
      region: $region
      leagueProfileId: $leagueProfileId
      queue: $queue
      role: $role
      championId: $championId
      lp: $lp
      gameId: $gameId
      deltaLp: $deltaLp
      division: $division
      tier: $tier
    )
  }
`;

export const UpdateLeagueRank = gql`
  mutation UpdateLeagueRank(
    $region: Region!
    $summonerId: String!
    $summonerName: String!
    $queueType: RankedQueue!
    $tier: Tier!
    $rank: Int!
    $wins: Int!
    $losses: Int!
    $season: Int!
    $leaguePoints: Int!
    $leagueId: String
    $leagueName: String
    $series: String
  ) {
    updateLeagueRank(
      region: $region
      summonerId: $summonerId
      summonerName: $summonerName
      queueType: $queueType
      tier: $tier
      rank: $rank
      wins: $wins
      losses: $losses
      season: $season
      leaguePoints: $leaguePoints
      leagueId: $leagueId
      leagueName: $leagueName
      series: $series
    )
  }
`;
